import styled from 'styled-components/macro'
import { BlueButton } from '../common/Button'

const ButtonNew = styled(BlueButton)`
  text-transform: uppercase;
  letter-spacing: 0.1rem;
`

export { ButtonNew }
